import * as Types from "../types";

export const startLogin = payload => ({
  type: Types.LOGIN_START,
  payload: payload,
});
